import React from "react";
import { CgPushChevronLeft, CgChevronLeft, CgChevronRight } from "react-icons/cg";

const Pagination = ({ paging, setPaging, countOfResults, showPagination, ...props }) => {
  if (!showPagination) {
    return null;
  }

  return (
    <div
      className="ccc-paging-container flex items-center justify-center space-x-2 select-none text-gray-500 mb-10"
      {...props}
    >
      <CgPushChevronLeft
        className={`text-xl ${paging.skip === 0 ? "text-gray-400" : "cursor-pointer"}`}
        onClick={() => {
          if (paging.skip !== 0) {
            setPaging({ ...paging, skip: 0 });
          }
        }}
      />
      <CgChevronLeft
        className={`text-xl ${paging.skip === 0 ? "text-gray-400" : "cursor-pointer"}`}
        onClick={() => {
          if (paging.skip !== 0 && paging.skip - paging.limit >= 0) {
            setPaging({ ...paging, skip: paging.skip - paging.limit });
          } else if (paging.skip !== 0) {
            setPaging({ ...paging, skip: 0 });
          }
        }}
      />
      <div className="ccc-paging-label ">
        {`${paging.skip} - ${
          paging.skip + paging.limit > countOfResults ? countOfResults : paging.skip + paging.limit
        } / ${countOfResults?.toLocaleString()}`}
      </div>
      <CgChevronRight
        className={`text-xl ${paging.skip + paging.limit >= countOfResults ? "text-gray-400" : "cursor-pointer"}`}
        onClick={() => {
          if (paging.skip + paging.limit < countOfResults) {
            setPaging({ ...paging, skip: paging.skip + paging.limit });
          }
        }}
      />
      {/* <CgPushChevronRight
        className={`text-xl ${paging.skip + paging.limit >= countOfResults ? "text-gray-400" : "cursor-pointer"}`}
        onClick={() => {
          if (paging.skip + paging.limit < countOfResults) {
            setPaging({ ...paging, skip: countOfResults - paging.limit });
          }
        }}
      /> */}
    </div>
  );
};

export default Pagination;
